import {useEffect} from "react";

const CurrencyHelper = (props: any) => {

    useEffect(() => {
        props.accountsList.map((account: any) => {

            if (account.number === props.hiddenAccountNumberFrom) {
                props.setCurrency(account.currency)
            }
        })
    }, [props.accountsList, props.hiddenAccountNumberFrom])

    useEffect(() => {
        props.accountsList.map((account: any) => {
            if (account.accountMainIban === props.payerAccount) {
                props.setCurrency(account.currency)
            }
        })
    }, [])

    return null
}

export default CurrencyHelper
